<template>
    <div class="flex justify-between">
        <div class="flex items-center gap-1">
            <label :for="'input-' + model.name">{{ t(`setting.${model.name}.title`) }}</label>
            <UTooltip
                v-if="shouldShowTooltip"
                :text="helpText"
                :delay-duration="0"
                :ui="{
                    content: 'h-fit overflow-visible',
                    text: 'whitespace-pre-line p-1',
                }"
            >
                <i class="i-ph-info inline-block" />
            </UTooltip>
        </div>
        <div class="w-[440px]">
            <account-picker
                class="max-w-md"
                :accounts="bookkeepingAccounts"
                :account-no="innerValue"
                single-pane
                @on-account-selected="onAccountSelected"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import {computed, ref} from 'vue'
import AccountPicker from '@/account-picker/AccountPicker.vue'
import { bookkeepingAccounts } from '@/bookkeeping-account/bookkeepingAccount.service'
import {Setting} from '@/setting/setting.service'
import {useI18n} from 'vue-i18n'
import {AccountOption} from '@/account-picker/accountPicker.service'

const {t} = useI18n()

const model = defineModel<Setting<string>>({required: true})
const innerValue = ref<string>(model.value.value ?? model.value.default ?? '')

const helpText = computed(() => {
    return t(`setting.${model.value.name}.tooltip`)
})

const shouldShowTooltip = computed(
    () => helpText.value !== ''
)

const onAccountSelected = (account: AccountOption) => {
    model.value.value = account.key
}

</script>

<style scoped>

</style>